<template>
  <SfButton
    class="information-pleat"
    :class="{ 'read-only': readOnly }"
    @click="$emit('pleat:click', $event)"
    @keypress.enter="$emit('pleat:click', $event)"
  >
    <div class="information-pleat__content">
      <div class="information-pleat__text">
        <slot />
      </div>
      <VaimoIcon
        v-if="!readOnly"
        :icon="iconName"
        class="information-pleat__icon"
        :label="iconName"
        :size="iconSize"
      />
    </div>
  </SfButton>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'InformationPleat',
  components: {
    SfButton,
    VaimoIcon: () => import('@/components/atoms/VaimoIcon.vue')
  },
  props: {
    iconName: {
      type: String,
      default: 'chevronright'
    },
    iconSize: {
      type: Number,
      default: 24
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['pleat:click']
});
</script>

<style lang="scss" scoped>
@import './InformationPleat';
</style>
